import { axios } from '@/services/axios';

export const getCountriesList = () => {
    const res = axios.get('/Countries/List');
    return res;
};
